<template>
  <span class="rf-icon" aria-hidden="true">
    <svg xmlns="http://www.w3.org/2000/svg" view-box="0 0 24 24" fill="none">
      <path
        fill="inherit"
        stroke="none"
        d="M5.62 21q-.7 0-1.16-.46T4 19.38V6.62q0-.7.46-1.16T5.62 5h1.76V2.77h1.08V5h7.16V2.77h1V5h1.76q.7 0 1.16.46T20 6.62v12.76q0 .7-.46 1.16t-1.16.46zm0-1h12.76q.24 0 .43-.2.2-.18.19-.42v-8.76H5v8.76q0 .24.2.43.18.2.42.19M5 9.62h14v-3q0-.24-.2-.43a.6.6 0 0 0-.42-.19H5.62q-.24 0-.43.2a.6.6 0 0 0-.19.42z"
      />
    </svg>
  </span>
</template>
